var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-option"},[_c('checkbox',{staticClass:"quiz-option__checkbox",attrs:{"isCorrect":_vm.option.is_correct,"label":_vm.option.title,"img":_vm.option.img},on:{"clicked":function($event){return _vm.onClick()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }